<app-dialog [config]="data.config" (actionButtonClicked)="dialogRef.close()">
    <ng-container dialog-title>
        <i class="fa fa-money mr-2 text-secondary"></i>
        Edit Account
    </ng-container>

    <ng-container dialog-process-in-progress *ngIf="editAccountForm && editAccountForm.form">
        <form [formGroup]="editAccountForm.form">
            <div [ngClass]="{'mb-3': editAccountForm.controls[0].errors.length > 0}">
                <app-panel-input
                    [formControlName]="editAccountForm.controls[0].name"
                    [control]="editAccountForm.controls[0]"
                ></app-panel-input>
            </div>
            <div [ngClass]="{'mb-3': editAccountForm.controls[1].errors.length > 0}">
                <app-panel-input
                    [formControlName]="editAccountForm.controls[1].name"
                    [control]="editAccountForm.controls[1]"
                ></app-panel-input>
            </div>
            <div [ngClass]="{'mb-3': editAccountForm.controls[2].errors.length > 0}">
                <app-select
                    [formControlName]="editAccountForm.controls[2].name"
                    [control]="editAccountForm.controls[2]"
                ></app-select>
            </div>
            <div [ngClass]="{'mb-3': editAccountForm.controls[3].errors.length > 0}">
                <app-select
                    [formControlName]="editAccountForm.controls[3].name"
                    [control]="editAccountForm.controls[3]"
                ></app-select>
            </div>
            <div [ngClass]="{'mb-3': editAccountForm.controls[4].errors.length > 0}">
                <app-select
                    [formControlName]="editAccountForm.controls[4].name"
                    [control]="editAccountForm.controls[4]"
                ></app-select>
            </div>
            <div [ngClass]="{'mb-3': editAccountForm.controls[5].errors.length > 0}">
                <app-select
                    [formControlName]="editAccountForm.controls[5].name"
                    [control]="editAccountForm.controls[5]"
                ></app-select>
            </div>
        </form>
    </ng-container>
</app-dialog>

